import ButtonComponent from './button/button.component';
import CheckboxComponent from './checkbox/checkbox.component';
import ColumnsComponent from './columns/columns.component';
import CurrencyComponent from './currency/currency.component';
import CustomComponent from './custom/custom.component';
import DatagridComponent from './datagrid/datagrid.component';
import DatetimeComponent from './datetime/datetime.component';
import EmailComponent from './email/email.component';
import FieldsetComponent from './fieldset/fieldset.component';
import FileCurrentComponent from './fileCurrent/fileCurrent.component';
import FileUploadComponent from './fileUpload/fileUpload.component';
import FormComponent from './form/form.component';
import GeoComponent from './geo/geo.component';
import HtmlelementComponent from './htmlelement/htmlelement.component';
import JsoneditorComponent from './jsoneditor/jsoneditor.component';
import KidComponent from './kid/kid.component';
import KpathComponent from './kpath/kpath.component';
import KtableComponent from './ktable/ktable.component';
import MfComponent from './mf/mf.component';
import NameComponent from './name/name.component';
import NumberComponent from './number/number.component';
import PanelComponent from './panel/panel.component';
import PasswordComponent from './password/password.component';
import PhoneNumberComponent from './phoneNumber/phoneNumber.component';
import PostaladdressComponent from './postaladdress/postaladdress.component';
import QrComponent from './qr/qr.component';
import QtyComponent from './qty/qty.component';
import RadioComponent from './radio/radio.component';
import RepreComponent from './repre/repre.component';
import SelectComponent from './select/select.component';
import SmartFieldComponent from './smartfield/smartfield.component';
import TabsComponent from './tabs/tabs.component';
import TextareaComponent from './textarea/textarea.component';
import TextEditorComponent from './texteditor/texteditor.component';
import TextfieldComponent from './textfield/textfield.component';
import UriComponent from './uri/uri.component';
import WellComponent from './well/well.component';
import WfCurrentComponent from './wfCurrent/wfCurrent.component';
import WfHistoComponent from './wfHisto/wfHisto.component';

/**
 * @type {Record<string,
 *     typeof ButtonComponent
 *   | typeof CheckboxComponent
 *   | typeof ColumnsComponent
 *   | typeof CurrencyComponent
 *   | typeof CustomComponent
 *   | typeof DatagridComponent
 *   | typeof DatetimeComponent
 *   | typeof EmailComponent
 *   | typeof FieldsetComponent
 *   | typeof FileCurrentComponent
 *   | typeof FileUploadComponent
 *   | typeof FormComponent
 *   | typeof GeoComponent
 *   | typeof HtmlelementComponent
 *   | typeof JsoneditorComponent
 *   | typeof KidComponent
 *   | typeof KpathComponent
 *   | typeof KtableComponent
 *   | typeof MfComponent
 *   | typeof NameComponent
 *   | typeof NumberComponent
 *   | typeof PanelComponent
 *   | typeof PasswordComponent
 *   | typeof PhoneNumberComponent
 *   | typeof PostaladdressComponent
 *   | typeof QrComponent
 *   | typeof QtyComponent
 *   | typeof RadioComponent
 *   | typeof RepreComponent
 *   | typeof SelectComponent
 *   | typeof SmartFieldComponent
 *   | typeof TabsComponent
 *   | typeof TextEditorComponent
 *   | typeof TextareaComponent
 *   | typeof TextfieldComponent
 *   | typeof UriComponent
 *   | typeof WellComponent
 *   | typeof WfCurrentComponent
 *   | typeof WfHistoComponent
 * >}
 */
export const componentClass = {
	'button':        ButtonComponent,
	'checkbox':      CheckboxComponent,
	'columns':       ColumnsComponent,
	'currency':      CurrencyComponent,
	'custom':        CustomComponent,
	'datagrid':      DatagridComponent,
	'datetime':      DatetimeComponent,
	'email':         EmailComponent,
	'fieldset':      FieldsetComponent,
	'fileCurrent':   FileCurrentComponent,
	'fileUpload':    FileUploadComponent,
	'form':          FormComponent,
	'geo':           GeoComponent,
	'htmlelement':   HtmlelementComponent,
	'jsoneditor':    JsoneditorComponent,
	'kid':           KidComponent,
	'kpath':         KpathComponent,
	'ktable':        KtableComponent,
	'mf':            MfComponent,
	'name':          NameComponent,
	'number':        NumberComponent,
	'panel':         PanelComponent,
	'password':      PasswordComponent,
	'phoneNumber':   PhoneNumberComponent,
	'postaladdress': PostaladdressComponent,
	'qr':            QrComponent,
	'qty':           QtyComponent,
	'radio':         RadioComponent,
	'repre':         RepreComponent,
	'select':        SelectComponent,
	'smartfield':    SmartFieldComponent,
	'tabs':          TabsComponent,
	'texteditor':    TextEditorComponent,
	'textarea':      TextareaComponent,
	'textfield':     TextfieldComponent,
	'uri':           UriComponent,
	'well':          WellComponent,
	'wfCurrent':     WfCurrentComponent,
	'wfHisto':       WfHistoComponent,
};

/**
 * @param {any} component
 * @returns {ButtonComponent
 *   | CheckboxComponent
 *   | ColumnsComponent
 *   | CurrencyComponent
 *   | CustomComponent
 *   | DatagridComponent
 *   | DatetimeComponent
 *   | EmailComponent
 *   | FieldsetComponent
 *   | FileCurrentComponent
 *   | FileUploadComponent
 *   | FormComponent
 *   | GeoComponent
 *   | HtmlelementComponent
 *   | JsoneditorComponent
 *   | KidComponent
 *   | KpathComponent
 *   | KtableComponent
 *   | MfComponent
 *   | NameComponent
 *   | NumberComponent
 *   | PanelComponent
 *   | PasswordComponent
 *   | PhoneNumberComponent
 *   | PostaladdressComponent
 *   | QrComponent
 *   | QtyComponent
 *   | RadioComponent
 *   | RepreComponent
 *   | SelectComponent
 *   | SmartFieldComponent
 *   | TabsComponent
 *   | TextEditorComponent
 *   | TextareaComponent
 *   | TextfieldComponent
 *   | UriComponent
 *   | WellComponent
 *   | WfCurrentComponent
 *   | WfHistoComponent
 *   | undefined
 * }
 */
export const createComponentInstance = component => {
	if (component.type in componentClass) {
		const cl = componentClass[component.type];
		return new cl(component);
	}
	return undefined;
};
